import React from "react";
import {
  Box,
  Section,
  Text,
} from "@quarkly/widgets";
import { Override, SocialMedia } from "@quarkly/components";

const CustomFooter = () => (
  <>
      <Section
        padding="80px 0 160px 0"
        md-padding="30px 0 30px 0"
        quarkly-title="Footer"
      >
        <Override
          slot="SectionContent"
          flex-direction="column"
          flex-wrap="no-wrap"
          display="flex"
        />
        <Box
          md-width="100%"
          empty-min-width="64px"
          empty-min-height="64px"
          empty-border-width="1px"
          empty-border-style="solid"
          empty-border-color="LightGray"
          width="100%"
          display="flex"
          align-self="auto"
          flex="1 1 0%"
          align-items="center"
          justify-content="center"
          flex-direction="column"
          flex-wrap="no-wrap"
        >
          <Text
            margin="0px 0px 12px 0px"
            color="--green"
            font="--headline5"
            lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
            md-margin="0px 0px 16px 0px"
          >
            Social Media:
          </Text>
          <SocialMedia
            linked-in="https://www.linkedin.com/company/renewable-energy-design/"
            youtube="https://www.youtube.com/@-redesign3570"
            facebook="https://www.facebook.com/UofA.RED/"
            telegram="https://www.facebook.com/groups/108922983122258/"
            instagram="https://www.instagram.com/red_ualberta/?hl=en"
            height="80px"
          // twitter="https://twitter.com/"
          >
            <Override
              slot="link"
              border-radius="50%"
              color="--green"
              hover-color="--light"
              background="transparent"
              hover-background="transparent"
              margin="0 8px"
            // href="https://www.google.ca/"
            />
          </SocialMedia>
        </Box>
        <Box
          margin="72px 0px 0px 0px"
          display="flex"
          md-margin="28px 0px 0px 0px"
          align-items="center"
          flex-direction="row"
          justify-content="center"
          flex-wrap="wrap"
        >
          <Text
            color="--light"
            font="--base"
            lg-font='normal 400 16px/1.5 "Varta", sans-serif'
            margin="0px 0px 0px 0px"
            text-align="left"
          >
            &copy; Renewable Energy Design, a UAlberta student
            club. All Rights Reserved. All rights reserved.
            {"\n\n"}
          </Text>
        </Box>
      </Section>
      {/* <Link
        font={"--capture"}
        font-size={"10px"}
        position={"fixed"}
        bottom={"12px"}
        right={"12px"}
        z-index={"4"}
        border-radius={"4px"}
        padding={"5px 12px 4px"}
        background-color={"--dark"}
        opacity={"0.6"}
        hover-opacity={"1"}
        color={"--light"}
        cursor={"pointer"}
        transition={"--opacityOut"}
        quarkly-title={"Badge"}
        text-decoration-line={"initial"}
        href={"https://quarkly.io/"}
        target={"_blank"}
      >
        Made on Quarkly
      </Link> */}
      
  </>
);

export default CustomFooter;
